import React from "react";

function WarningMessage({ text }: { text: string }) {
  return (
    <p className="flex items-center gap-1.5 text-sm font-medium text-red-500">
      <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 3 1.8 20.5A1 1 0 0 0 2.66 22h18.68a1 1 0 0 0 .86-1.5L12 3zm1 14h-2v-2h2v2zm0-4h-2V8h2v5z"
        />
      </svg>
      <span>{text}</span>
    </p>
  );
}

export function FieldRow({
  label,
  required,
  hint,
  error,
  children,
}: {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-black">
        {label} {required ? <span className="text-red-500">*</span> : null}
      </label>
      {hint ? <p className="text-xs text-black">{hint}</p> : null}
      {children}
      {error ? <WarningMessage text={error} /> : null}
    </div>
  );
}

